import * as type from './StatisticsType';
import { concatZeroCountWithData } from './StatisticsUtils';

export const initialState = {
    patientStatistics: null,
    formStatistics: null,
    patientRangeDate: { start: null, end: null },
    formRangeDate: { start: null, end: null }
};

export const statisticsReducer = (state = initialState, action) => {
    switch (action.type) {
        case type.GET_PATIENT_STATISTICS.SUCCESS: {
            const { data, start, end } = action.payload;
            return {
                ...state,
                patientStatistics: concatZeroCountWithData(data, start, end),
                patientRangeDate: { start, end }
            };
        }
        case type.GET_FORM_STATISTICS.SUCCESS: {
            const { data, start, end } = action.payload;
            return {
                ...state,
                formStatistics: concatZeroCountWithData(data, start, end),
                formRangeDate: { start, end }
            };
        }
        default:
            return { ...state };
    }
};
